import {matchPath, useLocation} from "react-router";

import {kmAppPath} from "@pg-mono/km-routes";

import {View} from "../types/View";

const MATCHED_VIEW_ROUTES: {exact?: true; path: string; view: View}[] = [
    {path: kmAppPath.site.dashboard.base, view: View.DASHBOARD},
    {path: kmAppPath.site.offers.favourites.comparator, view: View.COMPARATOR, exact: true},
    {path: kmAppPath.site.offers.favourites.base, view: View.FAVORITE},
    {path: kmAppPath.site.offers.myInquiries.base, view: View.APPLICATION_SENT},
    {path: kmAppPath.site.offers.base, view: View.APPLICATION_SENT, exact: true},
    {path: kmAppPath.site.offers.dismissed.base, view: View.DISMISSED},
    {path: kmAppPath.site.offers.recommended.detail, view: View.HOME_MATCH, exact: true},
    {path: kmAppPath.site.user.base, view: View.SETTINGS}
];

export function useMatchedView() {
    const {pathname} = useLocation();

    const matchedRoute = MATCHED_VIEW_ROUTES.find(({exact, path}) => matchPath(pathname, {exact: exact === true, path, strict: exact === true}));

    return matchedRoute?.view ?? View.UNKNOWN;
}
import {matchPath, useLocation} from "react-router";

import {kmAppPath} from "@pg-mono/km-routes";

import {View} from "../types/View";

const MATCHED_VIEW_ROUTES: {exact?: true; path: string; view: View}[] = [
    {path: kmAppPath.site.dashboard.base, view: View.DASHBOARD},
    {path: kmAppPath.site.offers.favourites.comparator, view: View.COMPARATOR, exact: true},
    {path: kmAppPath.site.offers.favourites.base, view: View.FAVORITE},
    {path: kmAppPath.site.offers.myInquiries.base, view: View.APPLICATION_SENT},
    {path: kmAppPath.site.offers.base, view: View.APPLICATION_SENT, exact: true},
    {path: kmAppPath.site.offers.dismissed.base, view: View.DISMISSED},
    {path: kmAppPath.site.offers.recommended.detail, view: View.HOME_MATCH, exact: true},
    {path: kmAppPath.site.user.base, view: View.SETTINGS}
];

export function useMatchedView() {
    const {pathname} = useLocation();

    const matchedRoute = MATCHED_VIEW_ROUTES.find(({exact, path}) => matchPath(pathname, {exact: exact === true, path, strict: exact === true}));

    return matchedRoute?.view ?? View.UNKNOWN;
}
